(function () {
  var root = document.getElementById('totepz');
  if (!root) return;
  var canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
  var nameIn = root.querySelector('#totepz-name');
  var count = root.querySelector('[data-for="totepz-name"]');
  var err = root.querySelector('.totepz__error');
  var hidden = { name: root.querySelector('[data-totepz="name"]'), flag: root.querySelector('[data-totepz="flag"]') };
  var ready = false;
  var addBtn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
  var form = addBtn ? (addBtn.form || addBtn.closest('form')) : null;
  if (form) {
    var formId = form.getAttribute('id');
    if (!formId) { formId = 'totepz-product-form'; form.setAttribute('id', formId); }
    Object.keys(hidden).forEach(function (k) { hidden[k].setAttribute('form', formId); hidden[k].disabled = false; });
  }
  function draw() {
    if (!ready || !window.drawTote) return;
    window.drawTote(ctx, { name: nameIn.value || nameIn.placeholder }, canvas.width / window.toteSize.W);
  }
  function sync() {
    hidden.name.value = nameIn.value.replace(/\s+/g, ' ').trim();
    count.textContent = nameIn.value.length + '/14';
    if (hidden.name.value) { root.classList.remove('totepz--invalid'); err.hidden = true; }
    draw();
  }
  nameIn.addEventListener('input', sync);
  document.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    sync();
    if (!hidden.name.value) {
      e.preventDefault(); e.stopImmediatePropagation();
      root.classList.add('totepz--invalid'); err.hidden = false;
      nameIn.scrollIntoView({ behavior: 'smooth', block: 'center' }); nameIn.focus({ preventScroll: true });
    }
  }, true);
  function loadFont(family, url) {
    return new FontFace(family, 'url(' + url + ')').load().then(function (ff) { document.fonts.add(ff); });
  }
  function start() {
    if (!window.drawTote) return setTimeout(start, 50);
    Promise.all([
      loadFont('BIW Pet Name', root.dataset.nameFont),
      loadFont('BIW Pet Type', root.dataset.typeFont),
      loadFont('BIW Pet Type Bold', root.dataset.typeBold)
    ]).catch(function () {}).then(function () { ready = true; sync(); });
  }
  sync();
  start();
})();
